import { createContext, useContext } from 'react';

import type { PaletteMode } from '@mui/material';

export const ThemeContext = createContext<PaletteMode>('light');

export const useApplicationTheme = () => useContext(ThemeContext);
